import { InjectionToken } from '@angular/core';
import { ReactiveFormsModule } from '@angular/forms';
import { DynamicValidatorMessageDirective } from '../../../directives/dynamic-validator-message.directive';

export interface ValidationErrorMessage {
  [key: string]: (args?: any) => string;
}

export const DynamicValidationDependencies = [
  ReactiveFormsModule,
  DynamicValidatorMessageDirective
];

export const ERROR_MESSAGES = {
  required: () => 'This field is required',
  email: () => 'Please enter a valid email address',
  phone: () => 'Please enter a valid phone number',
  creditCartNumber: () => 'Please enter a valid credit card number',
  creditCartExpDate: () => 'Please enter a valid expiration date (Format: MM/YYYY)',
  creditCartCvc: () => 'Please enter a valid CVC',
  creditCartZipCode: () => 'Please enter a valid zip code',
  maxlength: ({ requiredLength, actualLength }: any) =>
    'Field must be ' +
    requiredLength +
    ` characters or less (currently: ${actualLength})`,
  requiredLength: (requiredLength: any) =>
    'Field must be ' + requiredLength + ' characters long',
  timeRange: (data: any) => {
    if (data === true || !data.timeRanges || data.timeRanges.length === 0) {
      return 'Please select a valid time';
    } else {
      return `Please select a time between ${data.timeRanges.join(', ')}`;
    }
  },
  passwordContainCapitalLetter: () => 'Password should contain capital letter',
  passwordContainSmallLetter: () => 'Password should contain small letter',
  passwordContainNumber: () => 'Password should contain number',
  passwordContainSpecialCharacter: () => 'Password should contain special character',
};

export const VALIDATION_ERROR_MESSAGES =
  new InjectionToken<ValidationErrorMessage>('Validation Messages', {
    providedIn: 'root',
    factory: () => ERROR_MESSAGES
  });
